import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import _ from 'lodash';
import AppConstants, { CHANGE_EVENT } from '../constants/AppConstants';
import PaymentsConstants from '../constants/PaymentsConstants';
import AccountsStore from './AccountsStore';
import ManagePaymentsApiUtils from '../utils/ManagePaymentsApiUtils';
import ManagePaymentsParser from '../parsers/ManagePaymentsParser';
import DateUtils from '../utils/DateUtils';

let directDebitListIterator = {
  serviceCall: 0,
  success: 0,
};
let standingOrderListIterator = {
  serviceCall: 0,
  success: 0,
};
let serviceFail = false;
let archivePayments = null;
let paymentList = null;
let backUrl = 'WEB-OPEN-MOVEMONEY';
// todo global variable manipulation going on here!
let payment = null; // eslint-disable-line

class ManagePaymentsStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }
  getPaymentList() {
    return paymentList;
    // return this.sortPayment(paymentList, 'fromAccountName', 'asc');
  }
  getBackUrl() {
    return backUrl;
  }
  resetMoveMoneyUrl() {
    backUrl = 'WEB-OPEN-MOVEMONEY';
  }
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  reset() {
    directDebitListIterator = {
      serviceCall: 0,
      success: 0,
    };
    standingOrderListIterator = {
      serviceCall: 0,
      success: 0,
    };
    paymentList = null;
    archivePayments = null;
    serviceFail = false;
  }
  getArchivePayments() {
    return archivePayments;
  }
  updateDirectDebitArchiveData(archivedData) {
    const managePaymentParser = new ManagePaymentsParser();
    const archiveData =
      managePaymentParser.parseDirectDebitArchiveData(archivedData);
    archivePayments.push(archiveData);
  }
  updateStandingOrderArchiveData(archivedData) {
    const managePaymentParser = new ManagePaymentsParser();
    const archiveData =
      managePaymentParser.parseStandingOrderArchiveData(archivedData);
    archivePayments.push(archiveData);
  }
  updateStandingOrderList(activeStandingOrder) {
    const managePaymentParser = new ManagePaymentsParser();
    const activeData =
      managePaymentParser.parseStandingOrderActiveData(activeStandingOrder);
    paymentList.push(activeData);
  }
  updateDirectDebitList(activeDirectDebit) {
    const managePaymentParser = new ManagePaymentsParser();
    const activeData =
      managePaymentParser.parseDirectDebitActiveData(activeDirectDebit);
    paymentList.push(activeData);
  }
  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action.data;
    switch (actionType) {
      case AppConstants.LOGOUT_USER:
        this.reset();
        break;
      // Service call for payments list
      case PaymentsConstants.GET_PAYMENT_LIST:
        const accountList = AccountsStore.getAll();
        archivePayments = [];
        paymentList = [];
        serviceFail = false;
        _.map(accountList, (account) => {
          let accountName = account.displayName;
          // Calling Api to get Standing Order Payment list for capabale Account
          if (account.actionsAvailable['/account/mandates/so/read']) {
            standingOrderListIterator.serviceCall++;
            ManagePaymentsApiUtils.getStandingOrderPaymentList(
              account.id,
              accountName,
              account.accountNumber
            );
          }
          // Calling Api to get Direct Debits Payment list for capabale Account
          if (account.actionsAvailable['/account/mandates/dd/read']) {
            directDebitListIterator.serviceCall++;
            ManagePaymentsApiUtils.getDirectDebitPaymentList(
              account.id,
              accountName,
              account.accountNumber
            );
          }
        });
        if (
          directDebitListIterator.serviceCall === 0 &&
          standingOrderListIterator.serviceCall === 0
        ) {
          this.emitChange();
        }
        break;
      case PaymentsConstants.SET_PAYMENT_LIST_ERROR:
        if (!serviceFail) {
          serviceFail = true;
          paymentList = actionData;
          this.emitChange();
        }
        break;
      case PaymentsConstants.SET_MANAGE_PAYEMENT_BACK_URL:
        backUrl = actionData;
        break;

      case PaymentsConstants.SET_STANDING_ORDER_LIST_SUCCESS:
        if (!serviceFail) {
          standingOrderListIterator.success++;
          if (!_.isUndefined(actionData)) {
            const accountList = AccountsStore.getAll();
            actionData.mandates.map((standingStoreListDatas) => {
              const standingStoreListData = standingStoreListDatas;
              const isActive = standingStoreListData.is_active;
              standingStoreListData.fromAccountId = actionData.accountId;
              standingStoreListData.fromAccountNumber =
                actionData.accountNumber;
              standingStoreListData.fromAccountName = actionData.accountName;
              let isTransfer = false;
              _.forEach(accountList, (account) => {
                if (
                  account.number ===
                  `${standingStoreListData.sort_code}-${standingStoreListData.account_number}`
                ) {
                  isTransfer = true;
                  return false;
                }
              });
              standingStoreListData.payType = isTransfer
                ? 'Transfer'
                : 'Payment';
              switch (isActive) {
                case false:
                  this.updateStandingOrderArchiveData(standingStoreListData);
                  break;
                case true:
                  if (
                    standingStoreListData.hasOwnProperty('schedule') ||
                    (!standingStoreListData.hasOwnProperty('schedule') &&
                      DateUtils.comapareFromCurrentDate(
                        standingStoreListData.single.when
                      ) >= 0)
                  ) {
                    this.updateStandingOrderList(
                      standingStoreListData,
                      actionData
                    );
                  }
                  break;
                default: {
                  break;
                }
              }
              return false;
            });
          }
          if (
            standingOrderListIterator.success ===
              standingOrderListIterator.serviceCall &&
            directDebitListIterator.success ===
              directDebitListIterator.serviceCall
          ) {
            this.emitChange();
          }
        }
        break;
      case PaymentsConstants.SET_DIRECT_DEBIT_LIST_SUCCESS:
        if (!serviceFail) {
          directDebitListIterator.success++;
          if (!_.isUndefined(actionData)) {
            actionData.mandates.map((directDebitListDatas) => {
              const directDebitListData = directDebitListDatas;
              directDebitListData.fromAccountId = actionData.accountId;
              directDebitListData.fromAccountNumber = actionData.accountNumber;
              directDebitListData.fromAccountName = actionData.accountName;
              const isActive = directDebitListData.is_active;
              switch (isActive) {
                case false:
                  this.updateDirectDebitArchiveData(directDebitListData);
                  break;
                case true:
                  this.updateDirectDebitList(directDebitListData);
                  break;
                default: {
                  break;
                }
              }
              return false;
            });
          }
          if (
            standingOrderListIterator.success ===
              standingOrderListIterator.serviceCall &&
            directDebitListIterator.success ===
              directDebitListIterator.serviceCall
          ) {
            this.emitChange();
          }
        }
        break;
      case PaymentsConstants.SET_PAYMENT:
        payment = actionData;
        this.emitChange();
        break;
      case PaymentsConstants.RESET_PAYMENT:
        payment = null;
        this.emitChange();
        break;
      default:
    }
  }
}
export default new ManagePaymentsStore();
